export default function BenefitsSection() {
  const benefits = [
    {
      icon: 'ri-file-list-3-line',
      title: 'Простое управление заказами через таблицу',
      desc: 'Заполняйте одну таблицу — и все ваши заказы из Китая organised и под контролем. Никакой путаницы с десятками вкладок.',
      img: 'https://readdy.ai/api/search-image?query=Clean%20modern%20desk%20setup%20with%20laptop%20displaying%20organized%20spreadsheet%20next%20to%20a%20cup%20of%20coffee%20and%20small%20potted%20succulent%2C%20bright%20natural%20window%20light%2C%20productive%20morning%20workspace%20aesthetic%2C%20warm%20wood%20desk%20surface%2C%20focused%20organized%20atmosphere%2C%20lifestyle%20productivity%20photography%20with%20soft%20shadows&width=600&height=420&seq=benefit-spreadsheet-v2&orientation=landscape'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Прозрачные комиссии и стоимость доставки',
      desc: 'Вы всегда знаете, сколько стоит каждый товар и доставка. Никаких скрытых платежей — полная прозрачность на каждом этапе.',
      img: 'https://readdy.ai/api/search-image?query=Glass%20jar%20filled%20with%20various%20international%20coins%20and%20banknotes%20next%20to%20a%20calculator%20and%20receipt%20on%20light%20wooden%20desk%2C%20clear%20transparent%20financial%20concept%2C%20bright%20daylight%20through%20window%2C%20honest%20money%20management%20aesthetic%2C%20simple%20clean%20composition%2C%20trustworthy%20financial%20photography&width=600&height=420&seq=benefit-transparent-v2&orientation=landscape'
    },
    {
      icon: 'ri-rocket-line',
      title: 'Быстрый процесс заказа из Китая',
      desc: 'От заполнения таблицы до отправки заказа проходит минимум времени. Экономьте часы на оформлении покупок.',
      img: 'https://readdy.ai/api/search-image?query=Cardboard%20box%20with%20packing%20tape%20being%20sealed%20by%20hands%20on%20modern%20desk%2C%20tape%20dispenser%20and%20shipping%20labels%20nearby%2C%20action%20shot%20of%20packaging%20process%2C%20bright%20studio%20lighting%2C%20e-commerce%20fulfillment%20speed%20concept%2C%20dynamic%20movement%20captured%2C%20clean%20white%20background%2C%20efficient%20fast%20delivery%20theme&width=600&height=420&seq=benefit-fast-v2&orientation=landscape'
    },
    {
      icon: 'ri-stack-line',
      title: 'Поддержка массовых закупок',
      desc: 'Заказывайте десятки и сотни позиций одновременно. YOYBUY Spreadsheet оптимизирован для оптовых и массовых заказов.',
      img: 'https://readdy.ai/api/search-image?query=Stacks%20of%20various%20sized%20cardboard%20shipping%20boxes%20piled%20neatly%20in%20bright%20warehouse%20setting%2C%20organized%20bulk%20order%20preparation%20scene%2C%20industrial%20shelving%20in%20soft%20focus%20background%2C%20efficient%20logistics%20and%20wholesale%20concept%2C%20clean%20professional%20atmosphere%2C%20commercial%20inventory%20management%20photography&width=600&height=420&seq=benefit-bulk-v2&orientation=landscape'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Более безопасный процесс, чем ручные заказы',
      desc: 'Автоматическая проверка позиций снижает риск ошибок. Ваши заказы защищены на всех этапах — от оформления до получения.',
      img: 'https://readdy.ai/api/search-image?query=Shiny%20metallic%20padlock%20secured%20on%20a%20wrapped%20parcel%20box%20with%20tracking%20barcode%20visible%2C%20soft%20warm%20lighting%2C%20protection%20and%20security%20concept%2C%20e-commerce%20safe%20delivery%20theme%2C%20shallow%20depth%20of%20field%20with%20bokeh%20background%2C%20reassuring%20trustworthy%20atmosphere%2C%20premium%20product%20protection%20photography&width=600&height=420&seq=benefit-safe-v2&orientation=landscape'
    },
  ];

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">
            Почему пользователи выбирают <span className="text-primary-500">YOYBUY Spreadsheet</span>
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            Тысячи покупателей уже оценили удобство заказа через таблицу. Узнайте, почему это лучший способ покупать в Китае.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-6">
          {benefits.map((b, i) => (
            <div
              key={i}
              className="group bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden hover:border-primary-200/50 transition-all duration-300"
            >
              <div className="relative h-[120px] overflow-hidden">
                <img
                  src={b.img}
                  alt={b.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/20 to-transparent"></div>
              </div>
              <div className="p-5 pt-3 text-center">
                <div className="w-10 h-10 mx-auto mb-3 -mt-8 relative z-10 rounded-xl bg-primary-50 flex items-center justify-center group-hover:bg-primary-100 transition-colors">
                  <i className={`${b.icon} text-primary-500 text-lg w-5 h-5 flex items-center justify-center`}></i>
                </div>
                <h3 className="text-sm font-bold text-foreground-800 mb-2">{b.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{b.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}